export const BENEFIT_TYPE_DETAILS = {
  earnings: {
    label: <>Annual Earnings</>,
    suffix: <>per annum</>,
    colour: "cyan",
  },
  pension: {
    label: <>Annual Pension</>,
    suffix: <>per annum</>,
    colour: "amethyst",
  },
  lump_sum: {
    label: <>One-off Lump Sum</>,
    suffix: <>on retirement</>,
    colour: "darkorange",
  },
};

export const RETIREMENT_DATA = [
  {
    title: <>Projected Figures for Partial Retirement in </>,
    description: (
      <>
        {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
        veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
        commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
        velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
        occaecat cupidatat non proident, sunt in culpa qui officia deserunt
        mollit anim id est laborum. */}
      </>
    ),
    retirementType: "partial",
    schemes: [
      {
        title: <>Choose Legacy Scheme Benefits for Remedy Period</>,
        remedyChoice: "legacy",
      },
      {
        title: <>Choose alpha Scheme Benefits for Remedy Period</>,
        remedyChoice: "reform",
      },
    ],
  },
  {
    title: <>Projected Figures for Full Retirement in </>,
    description: (
      <>
        {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
        veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
        commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
        velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
        occaecat cupidatat non proident, sunt in culpa qui officia deserunt
        mollit anim id est laborum. */}
      </>
    ),
    retirementType: "full",
    schemes: [
      {
        title: <>Choose Legacy Scheme Benefits for Remedy Period</>,
        remedyChoice: "legacy",
      },
      {
        title: <>Choose alpha Scheme Benefits for Remedy Period</>,
        remedyChoice: "reform",
      },
    ],
  },
];
